import React from 'react';
import { ButtonComponent, type ButtonComponentProps } from './ButtonComponent';

export interface PrimaryActionButtonProps {
  label: string;
  onClick: () => void | Promise<void>;
  disabled?: boolean;
  loading?: boolean;
  variant?: 'contained' | 'outlined' | 'text';
  color?: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  loadingText?: string;
  sx?: ButtonComponentProps['sx'];
}

const PrimaryActionButton: React.FC<PrimaryActionButtonProps> = ({
  label,
  onClick,
  disabled = false,
  loading = false,
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  fullWidth = false,
  startIcon,
  endIcon,
  loadingText,
  sx,
}) => {
  const handleClick = async () => {
    if (onClick) {
      await onClick();
    }
  };

  return (
    <ButtonComponent
      onClick={handleClick}
      variant={variant}
      color={color}
      size={size}
      fullWidth={fullWidth}
      disabled={disabled}
      loading={loading}
      startIcon={startIcon}
      endIcon={endIcon}
      loadingText={loadingText}
      sx={{
         minWidth: 100,
        backgroundColor: "#1d4ed8", // primary-700
        color: "#fff",              // text-white
        "&:hover": {
          backgroundColor: "#1e40af", // primary-800
          transform: 'translateY(-1px)',
          boxShadow: variant === 'contained' ? 2 : 0,
        },
        "&:focus": {
          outline: "none",
          boxShadow: "0 0 0 4px #93c5fd", // focus:ring-4 focus:ring-primary-300
        },
        ...sx,
      }}
    >
      {label}
    </ButtonComponent>
  );
};

export default PrimaryActionButton;